// extracted by mini-css-extract-plugin
module.exports = {"imageslider":"ImageSlider_imageslider__2pKUs","sliderbutton":"ImageSlider_sliderbutton__1PtvZ","sliderimage":"ImageSlider_sliderimage__b48ZC"};